import { Button, Timeline, useConfirm } from "matsuri-ui"
import { css } from "@emotion/react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useNavigate } from "react-router-dom"
import { TimelineItem } from "./SchedulePage/TimelineItem"
import { JoinedOperation } from "./SchedulePage/JoinedOperation"
import { useJoinedSchedule } from "./SchedulePage/useJoinedSchedule"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { EmptyState } from "@/components/EmptyState/EmptyState"
import { LoadingMessage } from "@/components/LoadingMessage/LoadingMessage"
import { countSchedule } from "@/model/schedule"
import { useListActiveOperations } from "@/hooks/useListActiveOperations"
import { useTranslation } from "@/hooks/useTranslation"

export const UnreportedSchedulePage = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const confirm = useConfirm()
    const { token } = useAuth()
    const {
        data: { operations } = { operations: undefined },
        isLoading: isLoadingOperations
    } = useListActiveOperations(token)

    const unreportedOpertions =
        operations?.filter(op => op.cleaningStatus !== "prepared") ?? []

    const {
        joinedSchedules: joinedUnreportedSchedules,
        isLoading: isScheduleLoading
    } = useJoinedSchedule(token, unreportedOpertions)

    const loading = isLoadingOperations || isScheduleLoading

    const unreportedScheduleCount = countSchedule(joinedUnreportedSchedules)

    const isEmptyNotReportedSchedule = unreportedScheduleCount === 0

    // ダイアログ用の文言をレンダー時に事前翻訳リクエストしておく
    const confirmTitle = t("未報告があります")
    const confirmMessage = t("{{count}}件の未報告が残っています。", {
        params: { count: unreportedScheduleCount }
    })
    const confirmBack = t("予定表に戻りますか？")
    const confirmOk = t("OK")
    const confirmCancel = t("キャンセル")

    const handleBack = async () => {
        if (
            isEmptyNotReportedSchedule ||
            (await confirm({
                title: confirmTitle,
                message: (
                    <>
                        <p>{confirmMessage}</p>
                        <p>{confirmBack}</p>
                    </>
                ),
                confirmButtonText: confirmOk,
                cancelButtonText: confirmCancel
            }))
        ) {
            navigate("/schedule")
        }
    }

    return (
        <div
            css={css`
                padding-top: env(safe-area-inset-top, 0px);
            `}
        >
            <Button onClick={handleBack}>{t("戻る")}</Button>
            <MobileAppHeader title={<h3>{t("未報告一覧")}</h3>}>
                <div
                    css={css`
                        padding: 0 16px;
                    `}
                >
                    {loading ? (
                        <LoadingMessage />
                    ) : isEmptyNotReportedSchedule ? (
                        <EmptyState>{t("現在未報告はありません！")}</EmptyState>
                    ) : (
                        <Timeline
                            dates={joinedUnreportedSchedules}
                            renderItem={(props: JoinedOperation) =>
                                TimelineItem({ ...props, t })
                            }
                        />
                    )}
                </div>
            </MobileAppHeader>
        </div>
    )
}
